import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import icons from '../resources/icons';
import { Query, VejStykkeGetter, AdgangsAdresseGetter } from '../util/dawa.api';
import Searcher from './Searcher';
import { getString } from "../resources/strings";
import DetailsHandlerDef from "../details/DetailsHandlerDef";
/**
 *
 * @class Searches Dawa (http://dawa.aws.dk/)
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.DawaSearcher
 * @param {Object} options DawaSearcher expects these properties:
 * @param options.kommunekode {string} "*" Search all municipalities (Default), Search specific municipalities eg. "101" or "101|256"
 * @param options.srid {string} eg. "25832" (Default is 4326)
 *
 * @example
 * var dawaSearchOptions = {
 *     onSelect : function(result) {
 *          log('<b>Adresse valgt:</b> '+ result.title);},
 *     kommunekode: "151",
 *     matchesPhrase: "Begins with ",
 *     searchDelay: 200
 * };
 * searchers.push({title : 'Adresse', searcher : new Septima.Search.DawaSearcher(dawaSearchOptions)});
 *
 */

export default Class(Searcher,
/**  @lends Septima.Search.DawaSearcher# */
{
  roadIcon: icons.searchers.dawa.road,
  initialize: function initialize(options) {
    this.iconURI = icons.searchers.dawa.result;
    this.showOneStreet = false;
    this.kommunekode = null;
    this.source = "Dawa";

    if (typeof options === 'undefined') {
      this.Searcher({
        usesGeoFunctions: true,
        source: this.source
      });
    } else {
      if (options.kommunekode) this.kommunekode = options.kommunekode;
      if (options.showOneStreet) this.showOneStreet = options.showOneStreet;
      options.usesGeoFunctions = true;
      this.allowDetails = false;
      if (options.allowDetails) this.allowDetails = options.allowDetails;
      this.showDawaLinks = false;
      if (options.showDawaLinks) this.showDawaLinks = options.showDawaLinks;
      if (options.source) this.source = options.source;else options.source = this.source;
      this.Searcher(options);
    }

    this.registerType(this.source, {
      id: "adresse",
      singular: "Adresse",
      plural: "Adresser"
    });
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query, caller) {
      var queryOptions, dawaResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryOptions = {
                limit: query.limit + 3,
                query: query.queryString,
                showOneStreet: this.showOneStreet
              };
              if (this.kommunekode != null) queryOptions.kommunekode = this.kommunekode;
              _context.prev = 2;
              _context.next = 5;
              return new Query(queryOptions).query();

            case 5:
              dawaResult = _context.sent;
              caller.fetchSuccess(this.QueryResultFromDawaResult(query, dawaResult));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              caller.fetchError(this, _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 9]]);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  QueryResultFromDawaResult: function QueryResultFromDawaResult(query, dawaResult) {
    var queryResult = this.createQueryResult();
    var count = dawaResult.length;

    if (["list", "cut", "no-cut"].indexOf(query.type) !== -1) {
      var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = dawaResult.slice(0, hitsShown)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var thisHit = _step.value;
          this.addHitToQueryResult(thisHit, queryResult);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) {
        var newQuery;
        if (hitsShown > 0) newQuery = queryResult.addNewQuery(this.source, "adresse", "Flere adresser", "", query.queryString, null, null);else newQuery = queryResult.addNewQuery(this.source, "adresse", "Adresser", "", query.queryString, null, null);
        newQuery.image = icons.searchers.dawa.result;
      }
    } else {
      if (count > 0) {
        var _newQuery = queryResult.addNewQuery(this.source, "adresse", "Adresser", "", query.queryString, null, null);

        _newQuery.image = icons.searchers.dawa.result;
      }
    }

    return queryResult;
  },
  addHitToQueryResult: function addHitToQueryResult(thisHit, queryResult) {
    var presentation;
    var newQueryString;
    var newQuery;

    if (thisHit.type === "adgangsadresseinfo") {
      presentation = thisHit.tekst;
      var result = queryResult.addResult(this.source, "adresse", presentation, null, null, thisHit);
      result.id = thisHit.id;
      result.isComplete = false;
      result.image = icons.searchers.dawa.result;
    } else if (thisHit.type === "vej") {
      newQueryString = thisHit.vejnavn + " <select></select>" + ' ' + thisHit.postnummer + ' ' + thisHit.postdistrikt;
      presentation = thisHit.vejnavn + ' ' + thisHit.postnummer + ' ' + thisHit.postdistrikt;
      newQuery = queryResult.addNewQuery(this.source, "adresse", presentation, null, newQueryString, null, thisHit);
      newQuery.image = icons.searchers.dawa.road;
    } else if (thisHit.type === "vejnavn") {
      newQueryString = thisHit.vejnavn + " <select></select>";
      presentation = thisHit.vejnavn;
      newQuery = queryResult.addNewQuery(this.source, "adresse", presentation, null, newQueryString, null, thisHit);
      newQuery.image = icons.searchers.dawa.road;
    }
  },
  sq: function () {
    var _sq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(query) {
      var queryResult, querywkt, geom, x, y, data, result, xr, yr;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              queryResult = this.createQueryResult();

              if (!query.wkt) {
                _context2.next = 16;
                break;
              }

              querywkt = query.wkt;
              geom = this.translateWktToGeoJsonObject(querywkt);
              x = geom.coordinates[0];
              y = geom.coordinates[1];
              _context2.next = 8;
              return new AdgangsAdresseGetter().sq(x, y);

            case 8:
              data = _context2.sent;
              result = queryResult.addResult(this.source, "adresse", data.properties.vejstykke.navn + " " + data.properties.husnr + ", " + data.properties.postnummer.nr + " " + data.properties.postnummer.navn, null, data.geometry, data);
              result.id = data.id;
              result.isComplete = true;
              xr = data.geometry.coordinates[0];
              yr = data.geometry.coordinates[1];
              result.distance = Math.sqrt(Math.pow(x - xr, 2) + Math.pow(y - yr, 2));
              result.data.type = 'adgangsadresse';

            case 16:
              return _context2.abrupt("return", queryResult);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function sq(_x3) {
      return _sq.apply(this, arguments);
    }

    return sq;
  }(),
  error: function error(caller, jqXHR, textStatus, errorThrown) {
    caller.fetchError(this, errorThrown);
  },
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(id) {
      var queryResult, data, result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              queryResult = this.createQueryResult();
              _context3.next = 3;
              return new AdgangsAdresseGetter().get(id);

            case 3:
              data = _context3.sent;
              result = queryResult.addResult(this.source, "adresse", data.properties.vejstykke.navn + " " + data.properties.husnr + ", " + data.properties.postnummer.nr + " " + data.properties.postnummer.navn, null, data.geometry, data);
              result.id = id;
              result.isComplete = true;
              result.data.type = 'adgangsadresse';
              return _context3.abrupt("return", result);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function get(_x4) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  completeResult: function () {
    var _completeResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(result) {
      var data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!result.isComplete) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return", result);

            case 4:
              _context4.next = 6;
              return new AdgangsAdresseGetter().get(result.data.id);

            case 6:
              data = _context4.sent;
              result.type = 'adresse';
              result.data.type = 'adgangsadresse';
              result.data = data;
              result.geometry = data.geometry;
              result.isComplete = true;
              return _context4.abrupt("return", result);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function completeResult(_x5) {
      return _completeResult.apply(this, arguments);
    }

    return completeResult;
  }(),
  onSelect: function () {
    var _onSelect = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(result) {
      var getOptions, vejStykker, vejStykke, _getOptions, _vejStykker, _vejStykke;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!result.isNewQuery()) {
                _context5.next = 30;
                break;
              }

              if (!(result.data && result.data.type)) {
                _context5.next = 28;
                break;
              }

              if (!(result.data.type === 'vej')) {
                _context5.next = 16;
                break;
              }

              getOptions = {
                postnr: result.data.postnummer,
                navn: result.data.vejnavn
              };
              if (this.kommunekode != null) getOptions.kommunekode = this.kommunekode;
              _context5.next = 7;
              return new VejStykkeGetter().get(getOptions);

            case 7:
              vejStykker = _context5.sent;
              vejStykke = vejStykker[0];
              result.data = vejStykke;
              result.data.type = 'vej';
              result.geometry = vejStykke.geometry;
              result.data.vejkode = vejStykke.properties.kode;

              this._onSelectCallback(result);

              _context5.next = 28;
              break;

            case 16:
              if (!(result.data.type === 'vejnavn')) {
                _context5.next = 28;
                break;
              }

              _getOptions = {
                navn: result.data.vejnavn
              };
              if (this.kommunekode != null) _getOptions.kommunekode = this.kommunekode;
              _context5.next = 21;
              return new VejStykkeGetter().get(_getOptions);

            case 21:
              _vejStykker = _context5.sent;
              _vejStykke = _vejStykker[0];
              result.data = _vejStykke;
              result.data.type = 'vej';
              result.geometry = _vejStykke.geometry;
              result.data.vejkode = _vejStykke.properties.kode;

              this._onSelectCallback(result);

            case 28:
              _context5.next = 31;
              break;

            case 30:
              this._onSelectCallback(result);

            case 31:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function onSelect(_x6) {
      return _onSelect.apply(this, arguments);
    }

    return onSelect;
  }(),
  getDetailHandlersForResult: function getDetailHandlersForResult(result) {
    var _this = this;

    var detailHandlerDefs = [];

    if (this.allowDetails) {
      var dagiDetailsHandler = function dagiDetailsHandler(result) {
        return new Promise(function (resolve) {
          var atSitePhrase = getString("at_site");
          var items = [];

          var beliggenhed = _this.getBeliggenhed(result.data);

          var bebyggelse;
          var item;
          var setGeometries = [];

          if (beliggenhed.bebyggelse.length > 0) {
            bebyggelse = beliggenhed.bebyggelse[0];
            item = {
              type: "area",
              label: "Beliggenhed",
              value: bebyggelse.navn + " (" + bebyggelse.type + ")",
              hoverable: true,
              islistheader: true,
              result: {
                title: bebyggelse.navn,
                href: bebyggelse.href
              }
            };
            setGeometries.push(_this.setGeometry(item, bebyggelse.href));
            items.push(item);

            for (var i = 1; i < beliggenhed.bebyggelse.length; i++) {
              bebyggelse = beliggenhed.bebyggelse[i];
              item = {
                type: "area",
                label: " ",
                value: bebyggelse.navn + " (" + bebyggelse.type + ")",
                hoverable: true,
                result: {
                  title: bebyggelse.navn,
                  href: bebyggelse.href
                }
              };
              setGeometries.push(_this.setGeometry(item, bebyggelse.href));
              items.push(item);
            }
          }

          item = {
            type: "area",
            label: "Sogn",
            value: result.data.properties.sogn.navn,
            hoverable: true,
            islistheader: true,
            result: {
              title: result.data.properties.sogn.navn,
              href: result.data.properties.sogn.href
            }
          };
          setGeometries.push(_this.setGeometry(item, result.data.properties.sogn.href));
          items.push(item);
          if (_this.showDawaLinks) items.push({
            type: 'link',
            label: " ",
            liveIcons: [icons.jsonfile, icons.details.link],
            link: result.data.properties.sogn.href,
            linkTitle: 'Sognet ' + atSitePhrase + ' dawa.dk (json)'
          });
          item = {
            type: "area",
            label: "Ejerlav",
            islistheader: true,
            value: result.data.properties.jordstykke.ejerlav.navn
          };
          items.push(item);
          if (_this.showDawaLinks) items.push({
            type: 'link',
            label: " ",
            liveIcons: [icons.jsonfile, icons.details.link],
            link: result.data.properties.jordstykke.href,
            linkTitle: 'Matrikelnr ' + atSitePhrase + ' dawa.dk (json)'
          });
          if (_this.showDawaLinks) items.push({
            type: 'link',
            label: " ",
            liveIcons: [icons.jsonfile, icons.details.link],
            link: result.data.properties.politikreds.href,
            linkTitle: 'Politikredsen ' + atSitePhrase + ' dawa.dk (json)'
          });
          if (_this.showDawaLinks) items.push({
            type: 'link',
            label: " ",
            liveIcons: [icons.jsonfile, icons.details.link],
            link: result.data.properties.retskreds.href,
            linkTitle: 'Retskredsen ' + atSitePhrase + ' dawa.dk (json)'
          });
          if (_this.showDawaLinks) items.push({
            type: 'link',
            label: " ",
            liveIcons: [icons.jsonfile, icons.details.link],
            link: result.data.properties.opstillingskreds.href,
            linkTitle: 'Opstillingskredsen ' + atSitePhrase + ' dawa.dk (json)'
          });
          items.push({
            type: "area",
            label: "Zone",
            value: result.data.properties.zone,
            islistheader: true
          });
          item = {
            type: "area",
            label: "Vej",
            value: "(" + result.data.properties.vejstykke.kode + ") " + result.data.properties.vejstykke.navn,
            hoverable: true,
            islistheader: true,
            result: {
              title: result.data.properties.kommune.kode + "/" + result.data.properties.vejstykke.kode
            }
          };
          setGeometries.push(_this.setGeometry(item, result.data.properties.vejstykke.href));
          items.push(item);
          item = {
            type: "area",
            label: " ",
            value: "Vejpunkt",
            hoverable: true,
            result: {
              title: "Vejpunkt for " + result.title,
              geometry: {
                type: "Point",
                coordinates: result.data.properties.vejpunkt.koordinater
              }
            }
          };
          items.push(item);

          if (_this.showDawaLinks) {
            items.push({
              type: 'link',
              label: " ",
              liveIcons: [icons.jsonfile, icons.details.link],
              link: result.data.properties.vejstykke.href,
              linkTitle: 'Vejstykket ' + atSitePhrase + ' dawa.dk (json)'
            });
            items.push({
              type: 'link',
              label: " ",
              liveIcons: [icons.jsonfile, icons.details.link],
              link: result.data.properties.href,
              linkTitle: 'Adressen ' + atSitePhrase + ' dawa.dk (json)'
            });
          }

          Promise.all(setGeometries).then(function () {
            resolve(items);
          }, function () {
            resolve(items);
          });
        });
      };

      var detailHandlerDef = new DetailsHandlerDef({
        "buttonText": "Supplerende info for " + result.title,
        "buttonImage": icons.folderIcon,
        "handler": dagiDetailsHandler
      });
      detailHandlerDefs.push(detailHandlerDef);
    }

    return detailHandlerDefs;
  },
  setGeometry: function () {
    var _setGeometry = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(item, href) {
      var data;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return fetch2(href, {
                data: {
                  format: "geojson",
                  srid: "25832"
                }
              });

            case 3:
              data = _context6.sent;
              _context6.next = 9;
              break;

            case 6:
              _context6.prev = 6;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return");

            case 9:
              item.result.geometry = data.geometry;

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 6]]);
    }));

    function setGeometry(_x7, _x8) {
      return _setGeometry.apply(this, arguments);
    }

    return setGeometry;
  }(),
  getBeliggenhed: function getBeliggenhed(hit) {
    var beliggenhed = {
      title: "Beliggenhed",
      "bebyggelse": [],
      "value": ""
    };
    var ranks = {
      "storby": 1,
      "by": 2,
      "bydel": 3,
      "spredtBebyggelse": 4,
      "sommerhusområde": 5,
      "sommerhusområdedel": 6,
      "industriområde": 7,
      "kolonihave": 8
    };
    var bebyggelser = hit.properties.bebyggelser;
    bebyggelser.sort(function (a, b) {
      return ranks[a.type] - ranks[b.type];
    });
    beliggenhed.value = hit.properties.region.navn;

    for (var i = 0; i < bebyggelser.lenght; i++) {
      var thisBebyggelse = bebyggelser[i];
      beliggenhed.bebyggelse.push(thisBebyggelse);
      beliggenhed.value = beliggenhed.value + "->" + thisBebyggelse.navn;
      if (i === bebyggelser.length - 1) beliggenhed.title = thisBebyggelse.type;
    }

    return beliggenhed;
  },
  CLASS_NAME: 'Septima.Search.DawaSearcher'
});